import { create } from "zustand"
import { persist } from "zustand/middleware"

interface AircraftHeaderStore {
  isExpanded: boolean
  toggle: () => void
}

export const useAircraftHeaderStore = create<AircraftHeaderStore>()(
  persist(
    (set) => ({
      isExpanded: true,
      toggle: () => set((state) => ({ isExpanded: !state.isExpanded })),
    }),
    { name: "aircraft-header" },
  ),
)
